/**
 * @file ShellRailGuides.tsx
 * @brief Full-viewport left/right hairline guides for the admin content rail.
 *
 * @details
 * Fixed to the viewport (not per chrome segment) so the page spine stays
 * continuous through header, content gap, and footer. Hidden below `md`.
 *
 * @author DES
 * @date 29-07-2026
 */

import { shellRailMaxClass } from "./shell-rail";
import { cn } from "@/shared/theme/cn";

export function ShellRailGuides() {
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none fixed inset-y-0 left-1/2 z-[45] hidden -translate-x-1/2 md:block",
        shellRailMaxClass,
      )}
    >
      <div className="absolute inset-y-0 left-0 w-px bg-border/60" />
      <div className="absolute inset-y-0 right-0 w-px bg-border/60" />
    </div>
  );
}
